<template>
  <!--class="wrapper"  -->
  <div :class="deviceClass">
    <router-view id="tx-rank"></router-view>

    <!-- <div id="footer" class="clear wrap_bg"></div> -->

    <toast />
  </div>
</template>

<script setup>
import { init } from '@utils/api';
const { is_mobile, set_schools, set_sectors, set_rank_type, set_urls } =
  inject('GlobalStore');

const deviceClass = computed(() => ({
  mobile: is_mobile.value,
  pc: !is_mobile.value,
}));

onMounted(() => {
  // if (is_mobile.value) {
  //   import('@css/mobile/comv4.css');
  //   import('@css/mobile/mobile.scss');
  // } else {
  //   import('@css/pc/comv4.css');
  //   import('@css/pc/pc.scss');
  // }
  // 这里可以使用 jQuery
  // nie.util.copyRight();
  // nie.util.union.init();
  // nie.util.union.processUrl();
  // nie.util.union.getUnionCode();
  // nie.util.union.run();
  // // nie.util.share();
  // nie.util.shareV5();
  init().then((res) => {
    set_schools(res.data.schools);
    set_sectors(res.data.sectorInfo);
    set_rank_type(res.data.rank_type);
    set_urls(res.data.urls || {});
  });
});
</script>
